import React, { FunctionComponent, useState } from "react";
import styles from "./VideoEmbed.module.scss";
import VideoEmbedProps from "./VideoEmbedProps.interface";

import combineClasses from "helpers/combine-classes";
import IconViewer from "components/IconViewer/IconViewer";
import ReactPlayer from "react-player";

const VideoEmbed: FunctionComponent<VideoEmbedProps> = (props): JSX.Element => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(true);

    const isAutoplay = props.autoplay ? props.autoplay : false;
    const isPlayingClass = isPlaying === true ? styles.is_playing : undefined;
    const isLoop = props.loop ? props.loop : false;

    const onPlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    return (
        <div className={styles.wrapper}>
            {/* Sound Icon */}
            {props.soundIcon ? (
                <button className={styles.sound_icon_button} onClick={() => setIsMuted(!isMuted)}>
                    {isMuted ? (
                        <IconViewer className={styles.sound_icon} name="sound-on" />
                    ): (
                        <IconViewer className={styles.sound_icon} name="sound-off" />
                    )}
                </button>
            ) : null}

            {/* Media */}
            {props.src ? (
                <div className={styles.video_wrapper}>
                    <ReactPlayer
                        url={props.src}
                        className={styles.video}
                        loop={isLoop ? true : false}
                        muted={isMuted}
                        controls={isAutoplay ? false : true}
                        playing={isPlaying}
                        width={"100%"}
                        height={"100%"}
                        config={{
                            youtube: {
                                playerVars: {
                                    autoplay: isAutoplay ? 1 : 0,
                                    mute: isAutoplay ? 1 : 0, // Must mute to autoplay
                                    color: "white",
                                    controls: isAutoplay ? 0 : 1, // Hide controls on autoplay
                                    rel: 0,
                                    loop: isLoop ? 1 : 0,
                                    playsinline: 1,
                                    fs: 0,
                                    modestbranding: 1,
                                    showinfo: 0
                                }
                            }
                        }} />
                </div>
            ) : null}

            {!isAutoplay ? (
                <div className={combineClasses(styles.button_wrapper, isPlayingClass)} onClick={() => onPlayPause()}>
                    <button type="button" className={styles.button}>
                        {!isPlaying ? (
                            <IconViewer name="play" />
                        ) : (
                            <IconViewer name="pause" />
                        )}
                    </button>
                </div>
            ) : null}

            {typeof (props.aspectRatioX) !== "undefined" && typeof (props.aspectRatioY) !== "undefined" ? (
                <svg viewBox={`0 0 ${props.aspectRatioX} ${props.aspectRatioY}`} version="1.1" className={styles.ratio} preserveAspectRatio="xMidYMid" xmlSpace="preserve"></svg>
            ) : null}
        </div>
    );
};

export default VideoEmbed;